// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let AgentInfo = require("../../common/Agent/AgentInfo.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let ContactAgentButton = require("../../common/Agent/ContactAgentButton.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyPage__NextShowing = require("../../propertyPage/PropertyPage__NextShowing.bs.js");
let PropertyWizardRelay__Preview__Shared = require("./PropertyWizardRelay__Preview__Shared.bs.js");
let PropertyPage__RentalPropertySidecard__MlsInfo = require("../../propertyPage/PropertyPage__RentalPropertySidecard__MlsInfo.bs.js");
let PropertyPage__ForSalePropertySidecard__MlsInfo = require("../../propertyPage/PropertyPage__ForSalePropertySidecard__MlsInfo.bs.js");
let PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
let PropertyWizardRelayPreviewSidecard_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_formState_graphql.bs.js");
let PropertyWizardRelayPreviewSidecard_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_localDraft_graphql.bs.js");
let PropertyWizardRelayPreviewSidecard_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

let DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = PropertyWizardRelayPreviewSidecard_formState_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function PropertyWizardRelay__Preview__Sidecard(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, props.formState);
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, props.displayHelpers);
  let onMlsAtValid = PropertyWizardFormRelay__Validators__MLSTiming.OnMLSAt.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let mlsListingTypeValid = PropertyWizardFormRelay__Validators__MLSTiming.MLSListingType.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let mlsPreviewErrorMessages = PropertyWizardRelay__Preview__Shared.getMlsPreviewErrorMessages(mlsListingTypeValid, onMlsAtValid, props.onEditForm);
  let match = draft.draftProperty.propertyType;
  let tmp;
  tmp = match === "FOR_SALE" ? JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(PropertyPage__NextShowing.make, {
        showings: Stdlib_Option.getOr(displayHelpers.showings, []).map(x => x.fragmentRefs),
        timezone: DateFnsTz.Timezone.make(draft.timeZone)
      }),
      className: "pb-4 border-b-gray-200 border-b"
    }) : null;
  let tmp$1;
  if (mlsPreviewErrorMessages !== undefined) {
    tmp$1 = JsxRuntime.jsx("div", {
      children: mlsPreviewErrorMessages,
      className: "pb-4 border-b-gray-200 border-b"
    });
  } else {
    let match$1 = displayHelpers.mlsPlan;
    let match$2 = draft.draftProperty.propertyType;
    if (match$1 !== undefined) {
      let fragmentRefs = match$1.fragmentRefs;
      tmp$1 = match$2 === "FOR_SALE" ? JsxRuntime.jsx(PropertyPage__ForSalePropertySidecard__MlsInfo.FromMlsPlan.make, {
          mlsPlan: fragmentRefs,
          className: "pb-4 border-b-gray-200 border-b"
        }) : JsxRuntime.jsx(PropertyPage__RentalPropertySidecard__MlsInfo.FromMlsPlan.make, {
          mlsPlan: fragmentRefs,
          className: "pb-4 border-b-gray-200 border-b"
        });
    } else {
      tmp$1 = null;
    }
  }
  let match$3 = displayHelpers.agent;
  let agent = displayHelpers.agent;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          tmp,
          tmp$1,
          match$3 !== undefined ? JsxRuntime.jsx(AgentInfo.make, {
              agent: match$3.fragmentRefs,
              size: "medium"
            }) : null
        ],
        className: "px-4 flex flex-col gap-4 py-4"
      }),
      JsxRuntime.jsx("div", {
        children: agent !== undefined ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(ContactAgentButton.make, {
                agent: agent.fragmentRefs,
                fullWidth: true,
                variant: "Secondary",
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(IconV5.make, {
                      icon: "comment"
                    }),
                    "Contact agent"
                  ],
                  className: "flex items-center gap-2"
                })
              }),
              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                disabled: true,
                size: "small",
                icon: "share",
                children: "Share with client"
              })
            ],
            className: "my-6 px-4 grid grid-cols-1 xl:grid-cols-2 gap-2"
          }) : null,
        className: "bg-gray-100 border-t border-gray-200 rounded-b-md"
      })
    ],
    className: "border border-gray-200 rounded-md bg-white flex flex-col sticky top-16 max-w-sm"
  });
}

let MissingFieldMarker;

let Validators;

let Shared;

let ForSaleMlsInfo;

let RentalMlsInfo;

let make = PropertyWizardRelay__Preview__Sidecard;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.Shared = Shared;
exports.DraftFragment = DraftFragment;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.FormStateFragment = FormStateFragment;
exports.ForSaleMlsInfo = ForSaleMlsInfo;
exports.RentalMlsInfo = RentalMlsInfo;
exports.make = make;
/* IconV5 Not a pure module */
